import { useState, useEffect } from 'react';
import { Header } from '../../../common/Header/Header.jsx';
import { useHistory, useParams } from 'react-router-dom';
import { membershipService } from '../../../../services/membershipService.js';
import { dbHistoryService } from '../../../../services/dbHistoryService.js';
import { notify } from '../../../../assets/helpers/toast.js';
import { OrdeCard, OrderCard } from './OrderComponents.jsx';
import { ClientInfoCard } from './ClientInfoCard.jsx';
import { VehicleInfoCard } from './VehicleInfoCard.jsx';
import { AfiliationCard } from './AfiliationCard.jsx';
import { PaymentsCard } from './PaymentsCard.jsx';
import { ChangeCard } from './ChangeCard.jsx';
import { SalesButtons } from '../../../common/Buttons/Buttons.jsx';
import { salesMembershipStatus } from '../../../../assets/helpers/options.js';
import { statesService } from '../../../../services/statesService.js';
import {
  renameMembershipStatus,
  filterParams,
  removeBlankSpacesAndUppercase,
  clearObject,
  filterById,
  filterRCVOptions,
  displayMembershipCode,
} from '../../../../assets/helpers/funciones.js';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner.jsx';
import { salesRoles } from '../../../../assets/helpers/roles.js';
import authService from '../../../../services/authService.js';
import { productService } from '../../../../services/productService';
import { membershipCatalogService } from '../../../../services/membershipCatalogService';
import { giftCardService } from '../../../../services/giftCardService';
import { vehicleService } from '../../../../services/vehicleService';
import {
  RenewModal,
  EditHistoryModal,
} from '../../../common/Modals/Modals.jsx';
import {
  planStatus,
  getKmServiceOptions,
  getDefaultPlanKm,
  isNewPlanRulesActive,
  validateCodeEnum,
  codeTypeOptions,
  rcvEnum,
  codeTypeEnum,
  planTypes,
  membershipCodes,
  LANDING,
  vehicleUsageOptions,
  vehicleUsageEnum,
  vehiclesEnum,
} from '../../../../assets/helpers/options.js';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CraneCounter } from '../../../common/Buttons/CraneCounter.jsx';
import * as schemas from '../../../../assets/schemas/schemas';
import moment from 'moment';
import './Order.scss';
import { capitalize } from '../../../../assets/helpers/funciones.js';
import { surchargesService } from '../../../../services/surchargesService.js';

const itemsPerpage = [10, 25, 50, 100, 500];

export const Order = () => {
  const { membershipId } = useParams();
  const [membership, setMembership] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [planOptions, setPlanOptions] = useState([]);
  const [priceInfo, setPriceInfo] = useState('');
  const [discountId, setDiscountId] = useState('');
  const [rcvOptions, setRCVOptions] = useState([]);
  const [membershipOptions, setMembershipOptions] = useState([]);
  const [isVehicleDriver, setIsVehicleDriver] = useState('SI');
  const [ownerCitiesOptions, setOwnerCitiesOptions] = useState([]);
  const [vehicleFilerUsageOptions, setVehicleFilerUsageOptions] = useState([]);
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [ownerStatesOptions, setOwnerStatesOptions] = useState([]);
  const [editHistory, setEditHistory] = useState({
    isOpen: false,
    limit: itemsPerpage[0],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: true,
  });

  const [showRenewModal, setShowRenewModal] = useState({
    isOpen: false,
    selected: '',
  });

  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    setValue: setValue4,
    watch: watch4,
    setError: setError4,
  } = useForm({
    resolver: yupResolver(schemas.autorenovationSearchSchema()),
  });

  const history = useHistory();

  const actionOverMembership = (membership) => {
    getAvailableMemberships(membership);
  };

  const applyDiscount = (memId) => {
    if (!memId) {
      return true
    }
    return surchargesService
      .discountSurchargeAppliesToMembership({ memId })
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          // ? aqui colocar el set para mostrar el checkbox
          if (!response.data.appliesConfig) {
            return true
          } else if (response.data.appliesConfig && response.data.useRenewDiscount) {
            notify('Aplica descuento de renovación debido a una configuración de parámetros', 'info');
            return true
          } else if (response.data.appliesConfig && !response.data.useRenewDiscount) {
            notify('No aplica descuento de renovación debido a una configuración de parámetros', 'info');
            return false
          }
        } else {
          return false
        }
      })
      .catch((error) => {
        notify(`No se pudo validar el código de descuento`, 'error');
        console.log(`No se pudo validar el código de descuento`, error);
        return false
      });
  };

  const handleRenewModal = async (membership, planOptions) => {
    if (!membership) {
      setRCVOptions([]);
      setPlanOptions([]);
      // setValue4('rcv', 'ninguno');
      // setValue2("code", "")
      // reset2()
      setPriceInfo('');
    }
    const applyDiscountCheck = await applyDiscount(membership?._id)
    setValue4('useDiscount', applyDiscountCheck);

    actionOverMembership(membership);
  };
  const selfRenew = handleSubmit4(async (data) => {
    let params = {
      code: watch4('code'),
      rcvProduct: watch4('rcv') === 'ninguno' ? '' : watch4('rcv'),
      discountCodeId:
        watch4('codeType') === codeTypeEnum?.DISCOUNT ? discountId : '',
      giftcardId:
        watch4('codeType') === codeTypeEnum?.GIFTCARD ? discountId : '',
      km: watch4('km') ? watch4('km') : '',
      vehicleUsage: !['ninguno', rcvEnum?.NA].includes(watch4('rcv'))
        ? watch4('vehicleUsage')
        : '',
      useExtendedTow: watch4('hasExtendedTow')
        ? watch4('hasExtendedTow')
        : false,
      useRenewalDiscount: watch4('useDiscount') ? watch4('useDiscount') : false,
      rcvHolder: {
        isVehicleDriver: isVehicleDriver === 'SI' ? true : false,
        firstName: watch4('rcvHolderFirstName'),
        lastName: watch4('rcvHolderLastName'),
        fullName: `${watch4('rcvHolderFirstName')} ${watch4(
          'rcvHolderLastName'
        )}`,
        identification: watch4('rcvHolderIdentification'),
        identificationType: watch4('rcvHolderIdentificationType'),
        phonePrefix: watch4('rcvHolderPhonePrefix'),
        phoneNumber: watch4('rcvHolderPhoneNumber'),
        state: watch4('rcvHolderState'),
        city: watch4('rcvHolderCity'),
        address: watch4('rcvHolderAddress'),
      },
    };

    if (
      watch4('rcv') &&
      watch4('rcv') !== 'ninguno' &&
      !watch4('vehicleUsage')
    ) {
      setError4(`vehicleUsage`, {
        type: 'custom',
        message: 'Obligatorio',
      });
      return;
    }

    params.rcvHolder = clearObject(params.rcvHolder);

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .selfRenew(filterParams(params), showRenewModal?.selected?._id)
        .then((response) => {
          if ([200, 201]?.includes(response.status)) {
            if (response?.message) {
              notify(`${response.message}`, 'info');
            }
            history.push(`/afiliations/edit-order/${response?.data?._id}`);
            setIsloading(false);
            handleRenewModal();
            window?.location?.reload();
          } else {
            setIsloading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  });

  const calculateRenewalPrice = (membership, planOptions, discountId) => {
    const params = {
      rcv: watch4('rcv') === 'ninguno' ? '' : watch4('rcv'),
      code: watch4('code'),
      giftcard: watch4('codeType') === codeTypeEnum?.GIFTCARD ? discountId : '',
      vehicleUsage: !['ninguno', rcvEnum?.NA].includes(watch4('rcv'))
        ? watch4('vehicleUsage')
        : '',
      discountCode:
        watch4('codeType') === codeTypeEnum?.DISCOUNT ? discountId : '',
      useExtendedTow: watch4('hasExtendedTow')
        ? watch4('hasExtendedTow')
        : false,
      useRenewalDiscount: watch4('useDiscount') ? watch4('useDiscount') : false,
    };

    const [selectedOption] = planOptions?.filter(
      (p) => p?._id === watch4('code')
    );

    if (
      [membershipCodes?.GOLD, membershipCodes?.GOLDM]?.includes(
        selectedOption?.name
      )
    ) {
      if (!watch4('km')) {
        const defaultKm = getDefaultPlanKm(
          selectedOption?.name,
          (showRenewModal?.selected || membership)?.km
        );
        setValue4('km', defaultKm);
        params.km = defaultKm;
      } else {
        params.km = watch4('km');
      }
    }

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .calculateRenewalPrice(
          filterParams(params),
          showRenewModal?.selected?._id || membership?._id
        )
        .then((response) => {
          if (response.message === 'Success') {
            if (response.status === 200) {
              setPriceInfo(response?.data);
              setIsloading(false);
            }
            return null;
          }
          if (
            response.status === 400 &&
            [
              'discountCode contains an invalid value',
              'giftcard contains an invalid value',
            ]?.includes(response?.message)
          ) {
            notify(`Codigo Invalido`, 'info');
            setIsloading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch(() => { });
    }
  };

  const handleDiscountPercentage = () => {
    setValue4('useDiscount', watch4('useDiscount'));
    calculateRenewalPrice('', planOptions, discountId);
  };

  const getAvailableMemberships = (membership) => {
    setShowRenewModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showRenewModal?.isOpen,
        selected: membership ? membership : '',
      };
    });

    let params = {};

    params.landing = LANDING?.SELF_RENEWAL;
    params.class = membership?.vehicle?.classId;
    params.year = membership?.vehicle?.year;

    membershipCatalogService
      .getAvailableMemberships(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          let data = [...response?.data];

          if (membership?.membershipStatus === planStatus?.INCOMPLETED) {
            data = data?.filter(
              (d) => ![membershipCodes?.FREE]?.includes(d?.code)
            );
          }

          data = data?.filter(
            (d) =>
              ![membershipCodes?.RCV, membershipCodes?.RCV_ELITE]?.includes(
                d?.code
              )
          );

          for (let i = 0; i < data.length; i++) {
            data[i].name = displayMembershipCode(data[i]?.code);
          }

          setMembershipOptions(filterPlanType(data));

          if (membership) {
            const [option] = data?.filter(
              (p) => p?._id === membership?.membershipCode
            );
            setValue4('code', option?._id);
            getRCVs(membership, data);
          }

          if (!['ninguno', rcvEnum?.NA].includes(watch4('rcv'))) {
            setValue4('vehicleUsage', membership?.vehicle?.vehicleUsage);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const validateCode = () => {
    let discountType = '';

    if (watch4('codeType') === codeTypeEnum?.DISCOUNT) {
      discountType = 'discountCodes';
    }
    if (watch4('codeType') === codeTypeEnum?.GIFTCARD) {
      discountType = 'giftcards';
    }

    let params = {
      code: watch4('codigo'),
      type:
        watch4('codeType') === codeTypeEnum?.DISCOUNT
          ? validateCodeEnum?.RENEWAL
          : '',
    };

    if (params?.code) {
      giftCardService
        .validateDiscount(discountType, filterParams(params))
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setDiscountId(response?.data?._id);
            calculateRenewalPrice('', planOptions, response?.data?._id);
          } else {
            if ([404].includes(response.status)) {
              notify(`Codigo no encontrado o expirado`, 'info');
              return null;
            }

            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const handleDiscountCode = () => {
    removeBlankSpacesAndUppercase(watch4('codigo'), 'codigo', setValue4);

    if (watch4('codigo').length >= 6 && watch4('code')) {
      validateCode();
    }

    // if (watch4('codigo').trim().length > 6) {
    //   notify('Ingrese un código válido', 'info');
    //   setValue4('codigo', watch4('codigo').slice(0, 6));
    // }
  };

  const filterPlanType = (plans) => {
    if ([planTypes?.PLUSF4]?.includes(membership?.membershipPlan)) {
      plans = plans?.filter(
        (p) =>
          ![membershipCodes?.FREE, membershipCodes?.MOTORIDERAV].includes(
            p?.code
          )
      );
      return plans;
    }

    if ([planStatus?.INCOMPLETED].includes(membership?.membershipStatus)) {
      plans = plans?.filter(
        (p) =>
          ![
            membershipCodes?.FREE,
            membershipCodes?.RCV,
            membershipCodes?.RCV_ELITE,
          ].includes(p?.code)
      );
      return plans;
    } else return plans;
  };

  const handleCodeChange = () => {
    setValue4('codigo', '');
    setDiscountId('');
    calculateRenewalPrice('', planOptions, '');
  };

  const getRCVs = (membership, planOptions) => {
    if (watch4('code')) {
      const [selectedOption] = planOptions?.filter(
        (p) => p?._id === watch4('code')
      );

      if (
        [membershipCodes?.GOLD, membershipCodes?.GOLDM]?.includes(
          selectedOption?.name
        )
      ) {
        if (!watch4('km')) {
          setValue4(
            'km',
            getDefaultPlanKm(
              selectedOption?.name,
              (showRenewModal?.selected || membership)?.km
            )
          );
        }
      } else {
        setValue4('km', '');
      }

      productService
        .getRCVs({ membership: watch4('code') })
        .then((response) => {
          if (response.status === 200) {
            let data = [{ _id: 'ninguno', name: 'N/A' }, ...response?.data];
            let [basico] = data?.filter((p) => p?.name === rcvEnum?.RCV_STANDARD);

            data = filterRCVOptions(data);

            setRCVOptions(data);
            if (basico) {
              setValue4('rcv', basico?._id);
            }
            setValue4('codigo', '');
            setValue4('codeType', '');
            setDiscountId('');

            if (showRenewModal?.selected?._id || membership) {
              calculateRenewalPrice(membership, planOptions, '');
            }
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => { });
    }
  };

  const clearRCVForm = () => {
    setValue4('rcvHolderFirstName', '');
    setValue4('rcvHolderLastName', '');
    setValue4('rcvHolderIdentificationType', '');
    setValue4('rcvHolderIdentification', '');
    setValue4('rcvHolderState', '');
    setValue4('rcvHolderCity', '');
    setValue4('rcvHolderPhonePrefix', '');
    setValue4('rcvHolderPhoneNumber', '');
    setValue4('rcvHolderAddress', '');
  };

  const handleRCVHolder = (e) => {
    if (e?.target?.value === 'SI') {
      setValue4('isVehicleDriver', true);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
    if (e?.target?.value === 'NO') {
      setValue4('isVehicleDriver', false);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
  };

  const getCities = (state) => {
    statesService
      .getCities(state ? state : watch4('state'), true)
      .then((response) => {
        if (response.status === 200) {
          setOwnerCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => { });
    return true;
  };

  const handleCity = (e) => {
    getCities(e.target.value);
  };
  const getStates = () => {
    statesService
      .getStates({ isActive: true })
      .then((response) => {
        if (response.status === 200) {
          let states = response?.data?.states;
          setOwnerStatesOptions(states);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getSalesMembershipById = (membershipId) => {
    membershipService
      .getSalesMembershipById(membershipId)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setMembership(response?.data);
          getSalesVehicleClasses(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const handlePageChange = (event, value) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * editHistory?.limit,
      };
    });
  };

  const handleEditModal = () => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        isOpen: !editHistory?.isOpen,
      };
    });
  };

  const handleDateFrom = (e) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        dateFrom: e,
      };
    });
  };
  const handleDateTo = (e) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        dateTo: e,
      };
    });
  };

  const getHistory = (membershipId) => {
    let params = {
      page: editHistory?.page,
      limit: editHistory?.limit,
      from: moment(editHistory?.dateFrom).format('YYYY-MM-DD'),
      to: moment(editHistory?.dateTo).format('YYYY-MM-DD'),
    };

    dbHistoryService
      .getMembershipHistory(membershipId, params)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setEditHistory((prevState) => {
            return {
              ...prevState,
              data: response?.data?.history,
              count: response?.data?.total,
            };
          });
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const reloadMembership = () => {
    getSalesMembershipById(membershipId);
  };

  const upgradeOrder = (orderId) => {
    history.push(`/afiliations/payment/${orderId}/upgrade`);
  };
  const rcvOrder = (membership) => {
    if (
      !membership?.vehicle?.bodySerial ||
      !membership?.vehicle?.engineSerial ||
      !membership?.vehicle?.seats ||
      !membership?.vehicle?.vehicleUsage ||
      !membership?.customer?.profession ||
      !membership?.customer?.economicActivity ||
      !membership?.vehicle?.titleNumber
    ) {
      notify('Información incompleta del vehículo para solicitar RCV', 'error');
      return;
    } else {
      history.push(`/afiliations/payment/${membership?._id}/rcv`);
    }
  };

  const CertOrder = (membership) => {
    history.push(`/afiliations/payment/${membership?._id}/med-cert`);
  };

  const RCVCard = (membership) => {
    history.push(`/afiliations/payment/${membership?._id}/rcv-card`);
  };

  const membershipName = (membership) => {
    let status = renameMembershipStatus(membership?.membershipStatus);
    let id = 'Nro. ' + membership?.membershipId + ' ';

    if (status?.toUpperCase() !== 'INCOMPLETA' || membership?.mainMembership) {
      status = ' (' + capitalize(status) + ') ';
    } else {
      id = '';
    }

    return <span>{id + status}</span>;
  };

  const getSalesVehicleClasses = (membership) => {
    vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
          filterVehicleUse(
            response?.data?.classes,
            membership?.vehicle?.classId
          );
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const filterVehicleUse = (vehicleClasses, clase) => {
    const _class = filterById(vehicleClasses, clase);
    if ([vehiclesEnum?.AUTOMOVIL].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR].includes(
            option?._id
          )
        )
      );
    }
    if ([vehiclesEnum?.CAMIONETA].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [
            vehicleUsageEnum.PUBLIC,
            vehicleUsageEnum.PARTICULAR,
            vehicleUsageEnum.LOAD,
          ].includes(option?._id)
        )
      );
    }
    if ([vehiclesEnum?.RUSTICO].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR].includes(
            option?._id
          )
        )
      );
    }
    if ([vehiclesEnum?.MOTO].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.PARTICULAR, vehicleUsageEnum.LOAD].includes(
            option?._id
          )
        )
      );
    }
    if ([vehiclesEnum?.TRIMOTO].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.LOAD].includes(option?._id)
        )
      );
    }
    if (
      [
        vehiclesEnum?.CAMION,
        vehiclesEnum?.AMBULANCIA,
        vehiclesEnum?.GRUA,
      ].includes(_class.name)
    ) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.LOAD].includes(option?._id)
        )
      );
    }
    if ([vehiclesEnum?.AUTOBUS, vehiclesEnum?.MINIBUS].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR].includes(
            option?._id
          )
        )
      );
    }
    if (!_class.name) {
      setVehicleFilerUsageOptions(vehicleUsageOptions);
    }
  };

  useEffect(() => {
    getSalesMembershipById(membershipId);
    getStates();
  }, []);

  useEffect(() => {
    getHistory(membershipId);
  }, [
    editHistory?.page,
    editHistory?.limit,
    editHistory?.dateFrom,
    editHistory?.dateTo,
  ]);

  return (
    <>
      <CraneCounter handleModal={handleEditModal} />
      <EditHistoryModal
        handleDateTo={handleDateTo}
        handleDateFrom={handleDateFrom}
        modal={editHistory}
        handlePageChange={handlePageChange}
        handleModal={handleEditModal}
      />
      <RenewModal
        modal={showRenewModal}
        watch={watch4}
        register={register4}
        setValue={setValue4}
        errors={errors4}
        close={actionOverMembership}
        handleCity={handleCity}
        options={{
          planOptions: membershipOptions,
          rcvOptions: rcvOptions,
          codeTypeOptions: codeTypeOptions,
          KMServiceOptions: getKmServiceOptions(
            (showRenewModal?.selected || membership)?.km
          ),
          citiesOptions: ownerCitiesOptions,
          statesOptions: ownerStatesOptions,
          vehicleFilerUsageOptions: vehicleFilerUsageOptions,
        }}
        onChange={{
          getRCVs: getRCVs,
          handleCodeChange: handleCodeChange,
          handleDiscountCode: handleDiscountCode,
          calculateRenewalPrice: calculateRenewalPrice,
          handleDiscountPercentage: handleDiscountPercentage,
        }}
        handleRCVHolder={handleRCVHolder}
        isVehicleDriver={isVehicleDriver}
        priceInfo={priceInfo}
        action={selfRenew}
        membershipId={membershipId}
      />
      <Header />
      <LoadSpinner show={isLoading} />
      {membership && (
        <div className="service-with-container container">
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
            <h1 className="title-component" style={{ marginBottom: 0 }}>
              Orden {membershipName(membership)}
            </h1>
            {membership?.originCampaign && (
              <div
                style={{
                  border: '1px solid #f08d4b',
                  borderRadius: '6px',
                  color: '#f08d4b',
                  fontWeight: 500,
                  padding: '8px',
                  textAlign: 'center',
                  lineHeight: 1.2,
                  fontSize: '12px',
                  backgroundColor: '#fff0e5',
                }}
              >
                Canal de origen:
                <br />
                {membership?.originCampaign}
              </div>
            )}
          </div>
          <div className="breadcrumb-container"></div>
          <div className="filter-button-container"></div>
          <br />
          <div className="row">
            <div className="col-12 col-lg-9">
              <ClientInfoCard
                label={'INFORMACIÓN DEL CLIENTE'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
              <AfiliationCard
                label={'DATOS DE AFILIACIÓN'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
              <PaymentsCard
                label={'RESUMEN DE PAGOS'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
              <ChangeCard
                label={'RESUMEN DE VUELTOS'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
              <VehicleInfoCard
                label={'INFORMACIÓN DEL VEHÍCULO'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
              <OrdeCard
                label={'DOCUMENTOS DEL TITULAR Y DEL PAGO'}
                refresh={() => getSalesMembershipById(membershipId)}
                membership={membership}
              />
            </div>
            <div className="col-12 col-lg-3">
              <OrderCard
                membership={membership}
                refresh={() => getSalesMembershipById(membershipId)}
              />{' '}
              {membership?.membershipStatus ===
                salesMembershipStatus.VENCIDO && (
                  <SalesButtons
                    label={'Rescatar Plan'}
                    active={true}
                    action={() => handleRenewModal(membership)}
                  />
                )}
              {([
                salesMembershipStatus.POR_RENOVACION,
                salesMembershipStatus.POR_VENCER,
              ].includes(membership?.membershipStatus) ||
                [planTypes.F2, planTypes.PLUSF4].includes(
                  membership.membershipPlan
                )) && (
                  <SalesButtons
                    label={'Renovar Plan'}
                    active={true}
                    action={() => handleRenewModal(membership)}
                  />
                )}
              {membership?.membershipStatus !==
                salesMembershipStatus.INCOMPLETO && (
                  <>
                    {membership?.membershipStatus !==
                      planStatus.PENDING_DOCUMENTATION && (
                        <UpgradeButton
                          upgradeOrder={upgradeOrder}
                          membership={membership}
                        />
                      )}
                    <RCVButton action={rcvOrder} membership={membership} />
                  </>
                )}
              {membership?.membershipStatus !==
                planStatus.PENDING_DOCUMENTATION && (
                  <>
                    {!membership?.hasMedCert && (
                      <>
                        <MedCertButton label={'Solicitud Certificado Médico'} action={CertOrder} membership={membership} />
                      </>
                    )}
                    {!membership?.hasRcvCard && !["N/A"].includes(membership?.rcv) && (
                      <>
                        <MedCertButton label={'Solicitud Tarjeta RCV'} action={RCVCard} membership={membership} />
                      </>
                    )}
                  </>
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const UpgradeButton = (props) => {
  const { membership, upgradeOrder } = props;

  const isWithinFiveDays = (creationDate) => {
    const currentDate = moment();
    const createdDate = moment(creationDate);
    const differenceInDays = currentDate.diff(createdDate, 'days');

    return differenceInDays <= 5;
  };

  if (
    ['GOLD', 'GOLDM'].includes(membership?.membershipPlan) &&
    (isNewPlanRulesActive() || membership?.km === 300) &&
    membership.hasExtendedTow === true
  ) {
    return null;
  }

  if (
    [
      salesRoles?.SALES_ADMIN,
      salesRoles?.SALES_SUPERVISOR,
      salesRoles?.SALES_HUNTER,
      salesRoles?.SALES_FARMER,
      salesRoles?.SALES_COUNTER,
      salesRoles?.SALES_FARMER,
      salesRoles?.SALES_KEY_ACCOUNTS,
    ].includes(authService.getUserType()) &&
    ([
      salesMembershipStatus.ACTIVO,
      salesMembershipStatus.POR_RENOVACION,
    ].includes(membership?.membershipStatus) ||
      isWithinFiveDays(membership?.createdAt)) &&
    ['CLASSIC', 'PLUS', 'GOLD', 'GOLDM', 'CLASSICM', "PLUSM", 'MOTORIDER', 'BARATICO'].includes(
      membership?.membershipPlan
    )
  )
    return (
      <SalesButtons
        label={'Upgrade Plan'}
        active={true}
        action={() => upgradeOrder(membership?._id)}
      />
    );
  else return null;
};

export const RCVButton = (props) => {
  const { membership, action } = props;

  if (
    membership?.rcv === rcvEnum?.NA &&
    ![membershipCodes?.F2, membershipCodes?.PLUSF4]?.includes(
      membership?.membershipPlan
    )
  ) {
    return (
      <SalesButtons
        label={'Solicitud RCV'}
        active={true}
        action={() => action(membership)}
      />
    );
  } else return null;
};

export const MedCertButton = (props) => {
  const { membership, action, label } = props;
  return (
    <SalesButtons
      label={label}
      active={true}
      action={() => action(membership)}
    />
  );
};
